export default __webpack_public_path__ + "static/media/tratorSmall.d8ce7d75.png";